export enum BusinessType {
  CAFETERIA = 'CAFETERIA',
  PIZZERIA = 'PIZZERIA',
  RETAIL = 'RETAIL',
  FRANCHISEE = 'FRANCHISEE',
  FINE_DINING = 'FINE_DINING',
  BAR_AND_RESTAURANT = 'BAR_AND_RESTAURANT',
}

export enum BusinessStatus {
  NEW_BUSINESS = 'NEW_BUSINESS',
  EXISTING_BUSINESS = 'EXISTING_BUSINESS',
}

export enum BusinessSize {
  SMALL = '1',
  MEDIUM = '2-4',
  BIG = '5+',
}

export enum App {
  POS_APP = 'POS_APP',
  ONLINE_STORE = 'ONLINE_STORE',
  OOLIO_STORE = 'OOLIO_STORE',
  GUESTBOOK = 'GUESTBOOK',
  BACKOFFICE = 'BACKOFFICE',
  CUSTOMER_DISPLAY_APP = 'CUSTOMER_DISPLAY_APP',
  M_POS = 'M_POS',
  KITCHEN_DISPLAY_APP = 'KITCHEN_DISPLAY_APP',
  DEPUTY = 'DEPUTY',
  OOLIO_KIOSK = 'OOLIO_KIOSK',
  KIOSK = 'KIOSK',
  OOM = 'OOM',
  OOLIO_RESERVATION = 'OOLIO_RESERVATION',
  OOLIO_WAITLISTS = 'OOLIO_WAITLISTS',
  GIFTCARD = 'GIFTCARD',
}

export enum DeviceMode {
  F_POS = 'F_POS',
  M_POS = 'M_POS',
  KIOSK = 'KIOSK',
  ORB = 'ORB',
}

// Auto-clear timeout for removing "Ready" orders from display (in seconds)
export enum OrbAutoClearTimeout {
  THREE_MINUTES = 180,
  FIVE_MINUTES = 300,
  TEN_MINUTES = 600,
  FIFTEEN_MINUTES = 900,
}

export enum OnboardingAction {
  READ = 'READ',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum OnboardingArea {
  SETTINGS = 'SETTINGS',
  CATALOGUES = 'CATALOGUES',
}

export enum OnboardingCheckList {
  VENUES = 'VENUES',
  STORES_REGISTER_PROFILES = 'STORES_REGISTER_PROFILES',
  TAXES_FEES = 'TAXES_FEES',
  PAYMENT_TYPES = 'PAYMENT_TYPES',
  PAGES = 'PAGES',
  PRODUCTS = 'PRODUCTS',
}

// ActionSheet can be formed by using area, sections and actions separated by #

export enum OnboardingSection {
  VIEW_VENUE_SETUP = 'VIEW_VENUE_SETUP',
  VIEW_STORE_AND_REGISTER_SETUP = 'VIEW_STORE_AND_REGISTER_SETUP',
  VIEW_ADD_TAXES = 'VIEW_ADD_TAXES',
  VIEW_ADD_PAYMENT_TYPE = 'VIEW_ADD_PAYMENT_TYPE',
  ADD_A_PAGE_AND_PRODUCT = 'ADD_A_PAGE_AND_PRODUCT',
}

export enum OnboardingNavigationRoutes {
  NAVIGATE_TO_VENUE = 'NAVIGATE_TO_VENUE',
  NAVIGATE_TO_STORE_REGISTER = 'NAVIGATE_TO_STORE_REGISTER',
  NAVIGATE_TO_TAXES = 'NAVIGATE_TO_TAXES',
  NAVIGATE_TO_PAYMENT_TYPES = 'NAVIGATE_TO_PAYMENT_TYPES',
  NAVIGATE_TO_PRODUCTS = 'NAVIGATE_TO_PRODUCTS',
  NAVIGATE_TO_PAGES = 'NAVIGATE_TO_PAGES',
}

export enum Service {
  ACCOUNTS = 'accounts',
  ANALYTICS = 'analytics',
  CATALOGUES = 'catalogues',
  CUSTOMERS = 'customers',
  EVENTS = 'events',
  ORDERS = 'orders',
  ORGANIZATIONS = 'organizations',
  PRODUCTS = 'products',
  REPORTING = 'reporting',
  SERVICE_TEMPLATE = 'service-template',
  SHIFTS = 'shifts',
  STAFF = 'staff',
  VENUES = 'venues',
}

export enum FeatureLevel {
  ORGANIZATION = 'ORGANIZATION',
  VENUE = 'VENUE',
  STORE = 'STORE',
}

export enum SalesChannelCode {
  IN_STORE = 'IN_STORE',
  ONLINE = 'ONLINE',
}
